import config from '@/config.json';
import packagejson from './package.json';

console.log(`${packagejson.description} v${packagejson.version} is starting...`);

if (!config) {
  console.error('No config found');
} else {
  console.log('Config found');
  console.debug(Object.keys(config), { depth: null });
}

import('./src/bootstrap');